import { useSelector } from 'react-redux'

import { selectAppInitStatus, selectAppReady } from 'redux/selectors/AppInit'

/**
 * Hook for checking whether the app initialization sequence
 * (see initializeApp in redux/actions/AppInit) has completed.
 * When true it is safe to fetch data that depends on the signed-in
 * account, customer and global filter.
 */
export const useAppReady = () => {
  return useSelector(selectAppReady)
}

/**
 * Hook for getting the full app initialization status
 * ('idle' | 'initializing' | 'ready' | 'error').
 */
export const useAppInitStatus = () => {
  return useSelector(selectAppInitStatus)
}
